import { IBaseValueModel } from './base.model';

export interface ITransactionResponse {
  transactions: ITransaction[];
  total: number;
}

export interface ITransaction {
  phone: string;
  vrp: string;
  vrpFormat: string;
  zoneNumber: string;
  eventType: string;
  paymentType: string;
  time: string;
  sum: string;
  uuid: string;
  stopTime?: string;
}

export interface ITransactionFilterModel {
  page_index?: number;
  page_size?: number;
  start_time?: number;
  end_time?: number;
  type?: string;
  status?: TransactionStatusEnum;
  source?: string;
  search?: string;
  user?: IBaseValueModel;
}

export enum TransactionStatusEnum {
  SUCCESS = 'success',
  FAILED = 'failed',
  PROCESSING = 'processing',
}

export enum EventType {
  AccountsBuyAbonement = 'accountsBuyAbonement',
  AccountsRoadsideHold = 'accountsRoadsideHold',
  AccountsRoadsideStop = 'accountsRoadsideStop',
  PaymentsAccountRefill = 'paymentsAccountRefill',
}

export const EventTypeLabels: Record<EventType, string> = {
  [EventType.AccountsBuyAbonement]: 'ADMIN_TRANSACTION_EVENT_TYPE_BUY_ABONEMENT',
  [EventType.AccountsRoadsideHold]: 'ADMIN_TRANSACTION_EVENT_TYPE_PARKING_PAYMENT',
  [EventType.AccountsRoadsideStop]: 'ADMIN_TRANSACTION_EVENT_TYPE_PARKING_STOP',
  [EventType.PaymentsAccountRefill]: 'ADMIN_TRANSACTION_EVENT_TYPE_ACCOUNT_REFILL',
};
